import { render, staticRenderFns } from "./tinkPrivacy.vue?vue&type=template&id=4341cdf8&scoped=true"
import script from "./tinkPrivacy.vue?vue&type=script&lang=js"
export * from "./tinkPrivacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4341cdf8",
  null
  
)

export default component.exports